import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { z } from 'zod'

import { Button } from '@/components/ui/button'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import API from '@/lib/api'

import { MonetaBankCredentialsFormSchema } from './schema'

type MonetaBankCredentialsFormValues = z.infer<
  typeof MonetaBankCredentialsFormSchema
>

export const MonetaBankCredentialsForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const methods = useForm<MonetaBankCredentialsFormValues>({
    resolver: zodResolver(MonetaBankCredentialsFormSchema),
  })
  const { handleSubmit } = methods
  const { t } = useTranslation(undefined, {
    keyPrefix: 'bank.moneta',
  })

  const onValid = (values: MonetaBankCredentialsFormValues) => {
    setIsSubmitting(true)
    API.post('/api/v2/moneta-bank', values)
    .then(() => {
      toast.success(t('form.success.title'), {
        duration: 3000,
        closeButton: true,
      })

      methods.reset()
      onSuccess()
    })
    .finally(() => {
      setIsSubmitting(false)
    })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onValid)}>
        <div className="space-y-4">
          {/* <FormField
            name="name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.name.label')}</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          /> */}

          <FormField
            name="token"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t('form.token.label')}</FormLabel>
                <FormControl>
                  <Input {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <Button type="submit" className="w-full" disabled={isSubmitting}>
            {t('form.submit.label')}
          </Button>
        </div>
      </form>
    </FormProvider>
  )
}

MonetaBankCredentialsForm.displayName = 'MonetaBankCredentialsForm'
